import styled from "styled-components/macro";
import { Heading2 } from "styles/elements/Headings";
import { calculateRem } from "styles/mixins/calculateRem";
import type { ElearningThemeInterface } from "themes/elearningInterface.theme";

interface Props {
  theme: ElearningThemeInterface;
}

export const StyledDiagnosticMain = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
`;
export const StyledDiagnosticTestContentTitle = styled(Heading2)`
  margin: ${calculateRem(16)};
  text-align: left;
`;
export const StyledDiagnosticTestContentSubtitle = styled.div`
  display: grid;
  justify-content: left;
  margin: ${calculateRem(16)};
  text-align: left;
`;
export const StyledDiagnosticTestContentDescription = styled.p`
  text-align: left;
  color: ${(props: Props) => props.theme.palette.neutral._500};
`;
